module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/funcao-equipamento/funcao-equipamento.component.css
// module id = ./src/app/funcao-equipamento/funcao-equipamento.component.css
// module chunks = main